<template>
    <Modal
        title="Klant toevoegen"
        @close="close"
    >
        <div class="alert alert-danger">
            <ul>
                <li v-for="error in errors" :key="error">{{ error[0] }}</li>
            </ul>
        </div>

        <TextInput
            v-model="first_name"
            name="first_name"
            label="Voornaam"
            v-validate="'required'"
            type="text"
            class="mb-4"
            :error="formErrors.first('first_name')"
        />
        <TextInput
            v-model="last_name"
            name="last_name"
            label="Achternaam"
            v-validate="'required'"
            type="text"
            class="mb-4"
            :error="formErrors.first('last_name')"
        />
        <TextInput
            v-model="email"
            name="email"
            label="E-mailadres"
            v-validate="'required|email'"
            type="email"
            class="mb-4"
            :error="formErrors.first('email')"
        />
        <TextInput
            v-model="phone_number"
            name="phone_number"
            label="Telefoonnummer"
            v-validate="'required'"
            type="tel"
            class="mb-4"
            :error="formErrors.first('phone_number')"
        />
        <SelectInput
            v-model="country"
            name="country_id"
            field-label="Land"
            label="name"
            :options="countries"
            class="mb-4"
            validation="required"
        />

        <button
            type="submit"
            class="btn btn-red"
            :class="{ 'button-loading': isLoading }"
            @click="createCustomer"
        >
            {{ isLoading ? 'Verwerken...' : 'Opslaan' }}
        </button>
    </Modal>
</template>

<script>
    import { mapActions } from 'vuex';
    import axios from 'axios';

    import Modal from './Modal';
    import TextInput from '../inputs/TextInput';
    import SelectInput from '../inputs/SelectInput';

    export default {
        name: 'CreateCustomerModal',
        components: {
            Modal,
            TextInput,
            SelectInput,
        },
        data() {
            return {
                canSave: false,
                countries: [],
                country: null,
                email: null,
                errors: [],
                first_name: null,
                isLoading: false,
                last_name: null,
                phone_number: null,
            };
        },
        created() {
            this.getCountries();
        },
        methods: {
            ...mapActions('customers', [
                'create',
            ]),

            close() {
                document.querySelector('.modal-close').click();
                this.$emit('close');
            },

            async getCountries() {
                const { data } = await axios.get(this.route('api.countries.index'));
                this.countries = data;
            },

            async createCustomer() {
                try {
                    const customer = await this.create({
                        country_id: this.country.id,
                        email: this.email,
                        first_name: this.first_name,
                        last_name: this.last_name,
                        phone_number: this.phone_number,
                    });

                    this.$emit('add', customer);
                    this.isLoading = false;
                } catch ({ response: { data } }) {
                    this.errors = data.errors;
                }
            },
        },
    };
</script>
